import { configureStore  } from '@reduxjs/toolkit';
import app from './reducer';
import { initialState } from './shoppingCartReducer';
import { initialState as initialCustomerState } from './customerReducer';
import { initialState as initialCheckoutState } from './checkoutPageReducer';
import { initialState as initialTicketAddressState } from './ticketAddressReducer';
import { initialState as initialAccessCodesState } from './accessCodesReducer';
import { initialState as initialSponsorCodesState } from './sponsorCodeReducer';
import { initialState as initialCheckout } from './checkoutProcessReducer'
import { initialState as initialCrossSelling } from './crossSellingEventReducer'

const shoppingCartStorage = localStorage.getItem('shoppingCarts');
const customerStorage = localStorage.getItem('customer');
const selectedShipmentTypeStorage = localStorage.getItem('selectedShipmentType');
const orderCommentStorage = localStorage.getItem('orderComment');
const ticketAddressDataStorage = localStorage.getItem('ticketAddressData');
const accessCodesStorage = localStorage.getItem('accessCodesMap');
const sponsorCodesStorage = localStorage.getItem('sponsorCodesMap');
const sponsorCodeListStorage = localStorage.getItem('sponsorCodeList');
const checkoutStorage = localStorage.getItem('checkout');
const crossSellingStorage = localStorage.getItem('crossSelling')

let persistedShoppingCarts;
let persistedCustomer;
let persistedShipmentType;
let persistedOrderComment;
let persistedTicketAddressData;
let persistedAccessCodesMap;
let persistedSponsorCodesMap;
let persistedSponsorCodeList
let persistedCheckout;
let persistedCrossSelling;

try {
	persistedShoppingCarts = shoppingCartStorage ? Object.assign(
		JSON.parse(shoppingCartStorage),
		{
			seatInProcess: null,
		}
	) : initialState;
} catch (e) {
	console.error('couldn\'t parse shoppingcart. Error: ', e);
}

try {
	persistedCustomer = customerStorage ? JSON.parse(customerStorage) : initialCustomerState;
} catch (e) {
	console.error('couldn\'t parse customer. Error: ', e);
}

try {
	persistedShipmentType = selectedShipmentTypeStorage ? JSON.parse(selectedShipmentTypeStorage) : initialCheckoutState.selectedShipmentType;
} catch (e) {
	console.error('couldn\'t parse selected shipment type. Error: ', e);
}

try {
	persistedOrderComment = orderCommentStorage ? JSON.parse(orderCommentStorage) : initialCheckoutState.orderComment;
} catch (e) {
	console.error('couldn\'t parse order comment type. Error: ', e);
}

try {
	persistedTicketAddressData = ticketAddressDataStorage ? JSON.parse(ticketAddressDataStorage) : initialTicketAddressState.data;
} catch (e) {
	console.error('couldn\'t parse ticket address data. Error: ', e);
}

try {
	persistedAccessCodesMap = accessCodesStorage ? JSON.parse(accessCodesStorage) : initialAccessCodesState.plUuidCodeMap;
} catch (e) {
	console.error('couldn\'t parse access codes data. Error: ', e);
}

try {
	persistedSponsorCodesMap = sponsorCodesStorage ? JSON.parse(sponsorCodesStorage) : initialSponsorCodesState.codeUsagesPlUuidMap;
} catch (e) {
	console.error('couldn\'t parse access codes data. Error: ', e);
}

try {
	persistedSponsorCodeList = sponsorCodeListStorage ? JSON.parse(sponsorCodeListStorage) : initialSponsorCodesState.sponsorCodes;
} catch (e) {
	console.error('couldn\'t parse access codes data. Error: ', e);
}

try {
	persistedCheckout = checkoutStorage ? JSON.parse(checkoutStorage) : initialCheckout;
} catch (e) {
	console.error('couldn\'t parse checkout data. Error: ', e);
}

try {
	persistedCrossSelling = crossSellingStorage ? JSON.parse(crossSellingStorage) : initialCrossSelling;
} catch (e) {
	console.error('couldn\'t parse cross selling data. Error: ', e);
}


const stateFromStorage = Object.assign(
	{},
	{
		shoppingCart: persistedShoppingCarts,
		customer: persistedCustomer,
		checkoutPage: Object.assign(
			{},
			initialCheckoutState,
			{
				selectedShipmentType: persistedShipmentType,
				orderComment: persistedOrderComment,
			},
		),
		ticketAddress: Object.assign(
			{},
			initialTicketAddressState,
			{
				data: persistedTicketAddressData,
			},
		),
		accessCodes: Object.assign(
			{},
			initialAccessCodesState,
			{
				plUuidCodeMap: persistedAccessCodesMap,
			},
		),
		sponsorCodes: Object.assign(
			{},
			initialSponsorCodesState,
			{
				codeUsagesPlUuidMap: persistedSponsorCodesMap,
				sponsorCodes: persistedSponsorCodeList
			},
		),
		checkout: Object.assign(
			{},
			persistedCheckout,
		),
		crossSelling: Object.assign(
			{},
			persistedCrossSelling,
		)
	},
);

const store = configureStore({
	reducer: app,
	preloadedState: stateFromStorage
});

store.subscribe(() => {
	localStorage.setItem('shoppingCarts', JSON.stringify(store.getState().shoppingCart));
	localStorage.setItem('customer', JSON.stringify(store.getState().customer));
	localStorage.setItem('selectedShipmentType', JSON.stringify(store.getState().checkoutPage.selectedShipmentType));
	localStorage.setItem('orderComment', JSON.stringify(store.getState().checkoutPage.orderComment));
	localStorage.setItem('ticketAddressData', JSON.stringify(store.getState().ticketAddress.data));
	localStorage.setItem('accessCodesMap', JSON.stringify(store.getState().accessCodes.plUuidCodeMap));
	localStorage.setItem('sponsorCodesMap', JSON.stringify(store.getState().sponsorCodes.codeUsagesPlUuidMap));
	localStorage.setItem('sponsorCodeList', JSON.stringify(store.getState().sponsorCodes.sponsorCodes));
	localStorage.setItem('checkout', JSON.stringify(store.getState().checkout));
	localStorage.setItem('crossSelling', JSON.stringify(store.getState().crossSelling));
});
export default store;
